import React from 'react';
import type { FeatureModule } from '@/types/features';
import { FeatureModuleCard } from './feature-module-card';
import { cn } from '@/lib/utils';

interface FeatureCategorySectionProps {
  title: string;
  description: string;
  modules: FeatureModule[];
  onModeChange: (moduleId: string, mode: 'demo' | 'live') => void;
  isLoading?: boolean;
  recentlyChanged?: string | null;
  className?: string;
}

export const FeatureCategorySection: React.FC<FeatureCategorySectionProps> = ({
  title,
  description,
  modules,
  onModeChange,
  isLoading = false,
  recentlyChanged,
  className,
}) => {
  if (modules.length === 0) return null;

  return (
    <section className={cn('space-y-4', className)}>
      <div className="space-y-1">
        <h2 className="text-xl font-semibold tracking-tight">{title}</h2>
        <p className="text-sm text-muted-foreground">{description}</p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4">
        {modules.map((module) => (
          <FeatureModuleCard
            key={module.id}
            module={module}
            onModeChange={onModeChange}
            isLoading={isLoading}
            isRecentlyChanged={recentlyChanged === module.id}
          />
        ))}
      </div>
    </section>
  );
};
